/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Supov_OpenInputs */

const en_supov_open = /** @type {(inputs: Supov_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support and notes`)
};

/** @type {(inputs: Supov_OpenInputs) => LocalizedString} */
const ar_supov_open = en_supov_open;

/** @type {(inputs: Supov_OpenInputs) => LocalizedString} */
const he_supov_open = en_supov_open;

/** @type {(inputs: Supov_OpenInputs) => LocalizedString} */
const ur_supov_open = en_supov_open;

/** @type {(inputs: Supov_OpenInputs) => LocalizedString} */
const es_supov_open = en_supov_open;

/** @type {(inputs: Supov_OpenInputs) => LocalizedString} */
const fr_supov_open = en_supov_open;

/** @type {(inputs: Supov_OpenInputs) => LocalizedString} */
const de_supov_open = en_supov_open;

/** @type {(inputs: Supov_OpenInputs) => LocalizedString} */
const pt_supov_open = en_supov_open;

/** @type {(inputs: Supov_OpenInputs) => LocalizedString} */
const hi_supov_open = en_supov_open;

/** @type {(inputs: Supov_OpenInputs) => LocalizedString} */
const bn_supov_open = en_supov_open;

/**
* | output |
* | --- |
* | "Support and notes" |
*
* @param {Supov_OpenInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const supov_open = /** @type {((inputs?: Supov_OpenInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supov_OpenInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_supov_open(inputs)
	if (locale === "he") return he_supov_open(inputs)
	if (locale === "ur") return ur_supov_open(inputs)
	if (locale === "es") return es_supov_open(inputs)
	if (locale === "fr") return fr_supov_open(inputs)
	if (locale === "de") return de_supov_open(inputs)
	if (locale === "pt") return pt_supov_open(inputs)
	if (locale === "hi") return hi_supov_open(inputs)
	if (locale === "bn") return bn_supov_open(inputs)
	return /** @type {LocalizedString} */ ("Support and notes")
});